function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_213",
  "data-name": "Grupo 213",
  transform: "translate(-1072.353 -757.235)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_211",
  "data-name": "Caminho 211",
  d: "M1075.353,760.735h16v20h-16Z",
  fill: "none",
  stroke: "#060606",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_212",
  "data-name": "Caminho 212",
  d: "M1079.353,757.735h8v3h-8Z",
  fill: "none",
  stroke: "#060606",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_213",
  "data-name": "Caminho 213",
  d: "M1072.853,760.735h22",
  fill: "none",
  stroke: "#060606",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_214",
  "data-name": "Caminho 214",
  d: "M1079.353,764.235v12",
  fill: "none",
  stroke: "#060606",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_215",
  "data-name": "Caminho 215",
  d: "M1083.353,764.235v12",
  fill: "none",
  stroke: "#060606",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_216",
  "data-name": "Caminho 216",
  d: "M1087.353,764.235v12",
  fill: "none",
  stroke: "#060606",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

function SvgLixeira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixeira);
export default __webpack_public_path__ + "static/media/lixeira.d296df44.svg";
export { ForwardRef as ReactComponent };